import { z } from 'zod';


import Timestamp from '@/store/modules/models/global/Timestamp';

const DocumentParties = z.array(z.object({
    id: z.number(),
    title: z.string(),
    role: z.string(),
    order: z.number(),
    created_at: Timestamp,
  }));

export default DocumentParties;
